import React from "react";
import { useTheme } from "@mui/material/styles";
import { Alert, AlertTitle } from "@mui/material";

import DisconnectHistory from "components/pages/transmissions/modal/patient/tabs/subscription/disconnectHistory/DisconnectHistory";

const SubscibeInfoAlert = ({ optOutInfoText, lastSendInfoText }) => {
  const theme = useTheme();

  return (
    <Alert severity="info" color="info">
      {optOutInfoText && (
        <>
          <AlertTitle
            style={{ fontWeight: 700, color: theme.palette.info.main }}
          >
            SMS and Phone Call services are currently inactive.
          </AlertTitle>
          <div className="mb-3">{optOutInfoText}</div>
        </>
      )}

      {lastSendInfoText && (
        <>
          <AlertTitle
            style={{ fontWeight: 700, color: theme.palette.info.main }}
          >
            Late/Disconnected:
          </AlertTitle>
          <div className="mb-3">{lastSendInfoText}</div>
        </>
      )}

      <DisconnectHistory />
    </Alert>
  );
};

export default SubscibeInfoAlert;
